module.exports = __webpack_public_path__ + "img/pdfp.308e6277.svg";